import { datadogLogs, LogsInitConfiguration } from "@datadog/browser-logs";
import { datadogRum, RumInitConfiguration } from "@datadog/browser-rum";

import getEnv from "../getEnv";
import isProd from "../isProd";
import isTest from "../isTest";
import ignoreMessage from "./ignoreMessage";

const APPLICATION_ID = "64913c25-f3e9-457e-8e56-b212da04b87d";
const CLIENT_TOKEN = "pub64031eec811d4f31e4a911757f4a6cd1";
const SERVICE = "navigation";

const initDatadog = () => {
  if (isTest()) return;

  // Let's record them on prod only
  const enableSessionReplay = isProd();

  const rumInitConfiguration: RumInitConfiguration = {
    applicationId: APPLICATION_ID,
    clientToken: CLIENT_TOKEN,
    site: "datadoghq.com",
    env: getEnv(),
    service: SERVICE,
    version: import.meta.env.APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: enableSessionReplay ? 100 : 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    usePartitionedCrossSiteSessionCookie: true,
    compressIntakeRequests: true,
  };

  datadogRum.init(rumInitConfiguration);

  const logsInitConfiguration: LogsInitConfiguration = {
    clientToken: CLIENT_TOKEN,
    site: "datadoghq.com",
    env: getEnv(),
    service: SERVICE,
    version: import.meta.env.APP_VERSION,
    sessionSampleRate: 100,
    usePartitionedCrossSiteSessionCookie: true,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["error", "warn"],
    forwardReports: ["intervention", "deprecation"],
    beforeSend: (log) => {
      // discard ad blockers causing those errors
      if (log.http?.status_code === 404 || log.http?.status_code === 0) {
        return false;
      }

      const ignore = ignoreMessage(log.message);

      if (ignore) {
        return false;
      }

      return true;
    },
  };

  datadogLogs.init(logsInitConfiguration);
};

export default initDatadog;
